import { render, staticRenderFns } from "./notification-edit.vue?vue&type=template&id=0a931d5e&scoped=true&"
import script from "./notification-edit.vue?vue&type=script&lang=js&"
export * from "./notification-edit.vue?vue&type=script&lang=js&"
import style0 from "./notification-edit.vue?vue&type=style&index=0&id=0a931d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a931d5e",
  null
  
)

component.options.__file = "notification-edit.vue"
export default component.exports